/* eslint-disable @typescript-eslint/no-namespace */

namespace RegisterPage {
    const Simple = require('./simple')
    class RegisterPage extends Simple {
        public auth: any;
        constructor() {
            super('Register', true);
            const t = this;

            $(function () {
                $('[data-hideFromPage]').hide();
                $('#login-modal').empty();

                t.auth = new Simple.Auth(true, '_2');
                const params = (new URL(window.document.location as any)).searchParams;
                const parentCode = params.get('id');
                if (parentCode) {
                    const email = t.isParentReferentAssignCodeExist(parentCode);
                    if (email) {
                        if (email !== 'Referral') {
                            $('.loginModal-email').val(email).prop('disabled', true);
                            t.IsReferralLink = true;
                        }
                    }
                    $('.loginModal-register-form').show();
                }

                const promoCodeValue = params.get('PromoCode');
                const promoCodeEmail = params.get('Email');

                if (promoCodeValue && promoCodeEmail) {
                    t.isPromoCodeExist(promoCodeValue, promoCodeEmail);
                }

            })
        }

        //#region action on send Invitation Email
        isParentReferentAssignCodeExist(id: string) {
            let res = '';
            $.ajax({
                type: 'POST',
                url: '/MultipleNodeSelection/IsParentAssignInvitationLinksAvalible',
                data: { id: id },
                dataType: 'json',
                async: false,
                crossDomain: true,
                success: function (result) {
                    res = result;
                },
                error: function () {
                    $('.errorText').text('Failed to send Invitation Id').show()
                }
            });
            return res;
        }
        //#endregion

        //#region action on send Invitation Email
        isPromoCodeExist(promoCode: string, em: string) {
            const email = em;
            $.post('/ProfileAndSettings/isPromoCodeExist', { pc: promoCode }, data => {
                $('.loginModal-register-form').show();
                if (data.status == 'success' && data.result) {
                    $('.loginModal-promoCode .loginModal-promoCode-input').val(promoCode);
                    $('.loginModal-email').val(email);
                } else if (data.status == 'success') {
                    //alert('Promo Code limit is over, you couldn't use it');
                    $('.errorText').text('Promo Code expired.').show()
                }
                if (data.result == 'notexist') {
                    $('.errorText').text('Sorry that Promo Code are not valid').show()
                }
            });
        }
        //#endregion
    }
    const app = new RegisterPage();
    window['App'] = app;
}
